var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
(function() {
  "use strict";
  const _PackageProtectionApi = class _PackageProtectionApi {
    constructor(percentage, enabled) {
      __publicField(this, "variantIds", /* @__PURE__ */ new Set());
      __publicField(this, "variants", {});
      __publicField(this, "prices", []);
      this.percentage = percentage;
      this.enabled = enabled;
      if (_PackageProtectionApi.instance) {
        _PackageProtectionApi.instance = this;
      }
      return _PackageProtectionApi.instance;
    }
    get highestPrice() {
      return this.prices[this.prices.length - 1];
    }
    get lowestPrice() {
      return this.prices[0];
    }
    setVariants(variants) {
      this.prices.length = 0;
      this.variantIds.clear();
      for (const key of Object.keys(this.variants)) {
        delete this.variants[key];
      }
      this.prices.push(
        ...Object.keys(variants).map(Number).sort((a, b) => a - b)
      );
      for (const key of Object.keys(variants)) {
        this.variants[key] = variants[key];
        this.variantIds.add(variants[key]);
      }
    }
    async getNonPackageProtectionItems() {
      const cart = await window.weNexusCartApi.get();
      return cart.items.filter((item) => !this.variantIds.has(item.variant_id));
    }
    async getPackageProtectionItems() {
      const cart = await window.weNexusCartApi.get();
      return cart.items.filter((item) => this.variantIds.has(item.variant_id));
    }
    async calculate() {
      if (this.prices.length === 0) {
        throw new Error("No variants have been set");
      }
      const variants = await this.getNonPackageProtectionItems();
      const forPrice = variants.reduce((acc, item) => acc + item.final_line_price, 0) / 100;
      let coercedPrice = this.lowestPrice.toFixed(2);
      let actualPrice = forPrice / 100 * this.percentage;
      if (actualPrice <= this.highestPrice && actualPrice >= this.lowestPrice) {
        for (const price of this.prices) {
          if (price > actualPrice) {
            coercedPrice = price.toFixed(2);
            break;
          }
        }
      } else if (actualPrice > this.highestPrice) {
        coercedPrice = this.highestPrice.toFixed(2);
      } else if (actualPrice < this.lowestPrice) {
        coercedPrice = this.lowestPrice.toFixed(2);
      }
      return {
        actualPrice: Number(actualPrice.toFixed(2)),
        variantId: this.variants[coercedPrice],
        coercedPrice,
        forPrice
      };
    }
    async add() {
      const items = await this.getPackageProtectionItems();
      if (items.length > 0) {
        return;
      }
      const { variantId } = await this.calculate();
      const cart = await window.weNexusCartApi.append(
        [
          {
            id: variantId,
            quantity: 1
          }
        ],
        false
      );
      return cart.items.find((item) => item.variant_id === variantId);
    }
    async remove() {
      if (this.prices.length === 0) {
        throw new Error("No variants have been set");
      }
      const items = await this.getPackageProtectionItems();
      if (items.length === 0) {
        return;
      }
      await window.weNexusCartApi.remove(
        items.map((i) => i.variant_id),
        false
      );
      return items[0];
    }
    async change(variantId) {
      if (this.prices.length === 0) {
        throw new Error("No variants have been set");
      }
      const [item] = await this.getPackageProtectionItems();
      if (!item || variantId === item.variant_id) {
        return;
      }
      const cart = await window.weNexusCartApi.update(
        {
          [item.variant_id]: 0,
          [variantId]: 1
        },
        false
      );
      return cart.items.find((item2) => item2.variant_id === variantId);
    }
    async refresh() {
      const nonPackageProtectionItems = await this.getNonPackageProtectionItems();
      if (!this.enabled || nonPackageProtectionItems.length === 0) {
        await this.remove();
        return null;
      }
      const ppItems = await this.getPackageProtectionItems();
      if (ppItems.length === 0) {
        return this.add();
      }
      const { variantId } = await this.calculate();
      const item = ppItems.find((i) => i.variant_id === variantId);
      if (ppItems.length > 1 || !item || item.quantity > 1) {
        const updates = {};
        for (const item2 of ppItems) {
          updates[item2.variant_id] = 0;
        }
        updates[variantId] = 1;
        const cart = await window.weNexusCartApi.update(updates);
        return cart.items.find((i) => i.variant_id === variantId);
      }
      return this.change(variantId);
    }
  };
  __publicField(_PackageProtectionApi, "instance");
  let PackageProtectionApi = _PackageProtectionApi;
  class PackageProtectionClientBasic {
    constructor(api) {
      __publicField(this, "thumbnail", "https://prismwaterpipes.com/cdn/shop/files/Package-Protection_f8c90322-ba77-45d9-8890-077cf364bf93.jpg");
      __publicField(this, "infoPageLink", "/pages/package-protection");
      __publicField(this, "container", null);
      this.api = api;
    }
    formatPrice(price, currency) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        currency
      }).format(price);
    }
    async getPrice() {
      const { coercedPrice } = await this.api.calculate();
      const cart = await window.weNexusCartApi.get();
      return this.formatPrice(Number(coercedPrice), cart.currency);
    }
    async getCheckboxContainer(checked) {
      const container = document.createElement("div");
      const price = await this.getPrice();
      container.insertAdjacentHTML(
        "afterbegin",
        `
      <div class="wenexus-package-protection__content">
          <div class="wenexus-package-protection__image">
              <img src="${this.thumbnail}" alt="Package Protection" />
          </div>
          <div class="wenexus-package-protection__desc">
              <h5>Package Protection <a href="${this.infoPageLink}" target="_blank">ⓘ</a></h5>
              <p>Covers Damage, Loss & Theft for <strong class="protection-price">${price}</strong></p>
          </div>
      </div>
      <div class="wenexus-package-protection__toggle">
          <input type="checkbox">
      </div>
`
      );
      const checkbox = container.querySelector(
        ".wenexus-package-protection__toggle input"
      );
      container.className = "wenexus-package-protection";
      checkbox.checked = checked;
      this.container = container;
      return {
        container,
        checkbox
      };
    }
    async getStyleMarkup({
      accentColor,
      imageWidth = 65,
      containerGap = [0, 5],
      contentGap = [0, 5],
      descriptionFontWeight = "normal",
      descriptionFontSize = 1.3,
      descriptionMargin = [0, 0, 0, 0],
      titleFontSize = 1.8,
      hideDescriptionPage = true,
      containerMargin = [0, 5, 5, 0],
      containerJustify = "space-between",
      extraStyles = ""
    }) {
      return `
      <style>
         .wenexus-package-protection {
            display: flex;
            justify-content: ${containerJustify};
            align-items: center;
            margin: ${containerMargin == null ? void 0 : containerMargin.join("px ")};
            gap: ${containerGap[0]} ${containerGap[1]}px;
         }
         
    .wenexus-package-protection__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${contentGap[0]} ${contentGap[1]}px;
}

/* For Cart Drawer */
#CartDrawer .wenexus-package-protection__content {
  max-width: 400px; /* Wider for cart drawer */
  margin-right: 55px; /* Center align in standard cart */
}
#CartDrawer .wenexus-package-protection__toggle {
padding-right:15px;}
/* For Standard Cart */
.cart-page .wenexus-package-protection__content {
  max-width: 250px; /* Standard width */
  margin: 0 auto; /* Center align in standard cart */
}

/* Mobile Adjustments */
@media (max-width: 768px) {
  .wenexus-package-protection__content {
    max-width: 300px; /* Narrower for mobile */
    gap: 10px; /* Adjust gap for mobile */
  }
}
         .wenexus-package-protection__desc {
            text-align: left;
        }
         .wenexus-package-protection__image {
            max-width: ${imageWidth}px;
            display: flex;
         }
         
         .wenexus-package-protection__image img {
            width: 100%;
         }
         
         .wenexus-package-protection__desc h5 {
            font-size: ${titleFontSize}rem;
            line-height: 1;
         }
         
         .wenexus-package-protection__desc p {
            font-size: ${descriptionFontSize}rem;
            font-weight: ${descriptionFontWeight};
            margin: ${descriptionMargin == null ? void 0 : descriptionMargin.join("px ")}px;
         }
         
         .wenexus-package-protection__desc a {
            text-decoration: none;
            font-size: 1.0rem;
            outline: 0;
            color: #222;
            transition: .3s;
            ${hideDescriptionPage ? "display: none;" : ""}
         }
         
         .wenexus-package-protection__toggle {
         display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;
            accent-color: ${accentColor} !important;
            zoom: 1.45;
         }
         @media (max-width: 768px) {
  .wenexus-package-protection__desc h5 {
    font-size: 0.8rem; /* Smaller title on mobile */
  }

  .wenexus-package-protection {
    gap: 15px; /* Adjust gap for mobile */
  }

  .wenexus-package-protection__toggle {
    padding-right: 5px; /* Adjust margin on mobile */
  }
}
         ${extraStyles}
      </style>`;
    }
    getInsertionPointSelectors() {
      return [
        {
          selector: 'button[type="submit"][name="checkout"]',
          insertPosition: "before"
        }
      ];
    }
    refreshUI(_) {
      location.reload();
    }
    async refreshPriceUI() {
      if (this.container) {
        this.container.querySelector(".protection-price").textContent = await this.getPrice();
      }
    }
  }
  class PackageProtectionClientMandolin extends PackageProtectionClientBasic {
    static shouldUse() {
      return true;
    }
    getInsertionPointSelectors() {
      return [
        {
          selector: 'button[name="checkout"]',
          insertPosition: "before"
        }
      ];
    }
    refreshUI(_) {
      document.querySelectorAll("section-cart-drawer, section-cart").forEach((elem) => elem._rerenderCart());
    }
    async getStyleMarkup(options) {
      return super.getStyleMarkup({
        imageWidth: 66,
        containerMargin: [25, 0, 20, 0],
        containerJustify: "end",
        titleFontSize: 0.9,
        descriptionFontSize: 0.8,
        hideDescriptionPage: false,
        descriptionMargin: [2, 0, 0, 0],
        ...options,
        accentColor: "#788ff5"
      });
    }
    // onBeforeRefresh(context: RefreshContext): boolean {
    //   return !(location.pathname === '/cart' && context === 'trigger');
    // }
  }
  document.addEventListener("DOMContentLoaded", async () => {
    var _a, _b;
    const clients = [
      PackageProtectionClientMandolin
    ];
    const ClientClass = clients.find((Client) => {
      if (Client.shouldUse) {
        return Client.shouldUse();
      }
      return true;
    });
    if (!ClientClass) {
      return console.error("No package protection client found");
    }
    const enabledByDefault = true;
    const enabled = () => {
      const value = localStorage.getItem("package-protection-enabled");
      if (value === null) {
        return enabledByDefault;
      }
      return value === "true";
    };
    const packageProtectionApi = new PackageProtectionApi(
      Number(
        ((_a = document.getElementById("package-protection-percentage")) == null ? void 0 : _a.innerText) ?? 3
      ),
      enabled()
    );
    const client = new ClientClass(packageProtectionApi);
    const selectors = ((_b = client.getInsertionPointSelectors) == null ? void 0 : _b.call(client)) || [];
    async function refresh(context, force = false) {
      if (typeof client.onBeforeRefresh === "function") {
        const shouldContiue = await client.onBeforeRefresh(context);
        if (!shouldContiue) {
          return;
        }
      }
      const item = await packageProtectionApi.refresh();
      const oldItemId = localStorage.getItem("package-protection-item") || null;
      const newItemId = (item == null ? void 0 : item.variant_id.toString()) || null;
      localStorage.setItem(
        "package-protection-item",
        (item == null ? void 0 : item.variant_id.toString()) ?? ""
      );
      if (force || oldItemId !== newItemId) {
        client.refreshUI(item ?? null);
      }
    }
    packageProtectionApi.setVariants({
      "0.25": 45549030801662,
      "0.75": 45549031686398,
      "1.50": 45549031719166,
      "2.25": 45549031948542,
      "3.00": 45549032276222,
      "3.75": 45549032341758,
      "4.50": 45549032866046,
      "5.25": 45549033095422,
      "6.00": 45549033128190,
      "6.75": 45549033160958,
      "7.50": 45549034111230,
      "8.25": 45549034143998,
      "9.00": 45549034176766,
      "9.75": 45549034209534,
      "10.50": 45549034242302,
      "11.25": 45549034471678,
      "12.00": 45549034504446,
      "12.75": 45549034602750,
      "13.50": 45549034668286,
      "14.25": 45549034963198,
      "15.00": 45549034995966,
      "15.75": 45549035061502,
      "16.50": 45549035094270,
      "17.25": 45549035225342,
      "18.00": 45549035258110,
      "18.75": 45549035290878,
      "19.50": 45549035684094,
      "20.25": 45549035880702,
      "21.00": 45549036175614,
      "21.75": 45549036536062,
      "22.50": 45549036568830,
      "23.25": 45549036634366,
      "24.00": 45549036667134,
      "24.75": 45549036896510,
      "25.50": 45549038174462,
      "26.25": 45549038338302,
      "27.00": 45549038469374,
      "27.75": 45549039091966,
      "28.50": 45549039223038,
      "29.25": 45549039419646,
      "30.00": 45549040042238,
      "30.75": 45549040566526,
      "31.50": 45549040861438,
      "32.25": 45549041221886,
      "33.00": 45549041680638,
      "33.75": 45549042303230,
      "34.50": 45549042368766,
      "35.25": 45549042729214,
      "36.00": 45549042958590,
      "36.75": 45549043155198,
      "37.50": 45549044269310,
      "38.25": 45549044891902,
      "39.00": 45549045547262,
      "39.75": 45549045678334,
      "40.50": 45549045940478,
      "41.25": 45549047185662,
      "42.00": 45549050396926,
      "42.75": 45549051773182,
      "43.50": 45549052035326,
      "44.25": 45549052756222,
      "45.00": 45549053346046,
      "45.75": 45549053575422,
      "46.50": 45549054787838,
      "47.25": 45549055967486,
      "48.00": 45549056393470,
      "48.75": 45549058425086,
      "49.50": 45549059309822,
      "50.25": 45549060358398,
      "51.00": 45549060751614,
      "51.75": 45549061472510,
      "52.50": 45549063700734,
      "53.25": 45549064356094,
      "54.00": 45549065011454,
      "54.75": 45549065208062,
      "55.50": 45549065535742,
      "56.25": 45549066125566,
      "57.00": 45549066387710,
      "57.75": 45549066617086,
      "58.50": 45549067010302,
      "59.25": 45549068615934,
      "60.00": 45549069140222,
      "60.75": 45549069730046,
      "61.50": 45549069861118,
      "62.25": 45549070156030,
      "63.00": 45549070483710,
      "63.75": 45549071565054,
      "64.50": 45549072056574,
      "65.25": 45549073662206,
      "66.00": 45549073989886,
      "66.75": 45549074776318,
      "67.50": 45549075955966,
      "68.25": 45549077168382,
      "69.00": 45549077364990,
      "69.75": 45549078020350,
      "70.50": 45549078085886,
      "71.25": 45549078708478,
      "72.00": 45549079363838,
      "72.75": 45549079593214,
      "73.50": 45549080707326,
      "74.25": 45549081133310
    });
    window.weNexusCartApi.addListener(() => refresh("trigger"));
    if (typeof client.getStyleMarkup === "function") {
      document.head.insertAdjacentHTML(
        "beforeend",
        await client.getStyleMarkup({
          accentColor: "#788ff5",
          imageWidth: 62
        })
      );
    }
    for (const selector of selectors) {
      if (selector.shouldUse && !selector.shouldUse()) {
        continue;
      }
      const liveQuery = new window.WeNexusQuerySelectorLive(
        selector.selector,
        selector.boundaryParents
      );
      liveQuery.addListener(async (elements) => {
        for (const element of elements) {
          const { container, checkbox } = await client.getCheckboxContainer(
            enabled()
          );
          switch (selector.insertPosition) {
            case "before":
              element.insertAdjacentElement("beforebegin", container);
              break;
            case "after":
              element.insertAdjacentElement("afterend", container);
              break;
            case "inside":
              element.insertAdjacentElement("afterbegin", container);
              break;
            case "replace":
              element.replaceWith(container);
              break;
          }
          checkbox.addEventListener("change", async () => {
            localStorage.setItem(
              "package-protection-enabled",
              checkbox.checked.toString()
            );
            packageProtectionApi.enabled = enabled();
            await refresh("toggle", true);
          });
        }
      });
    }
    await refresh("initial");
  });
})();
